import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ChangePassword } from '@/features/auth/change-password'

const searchSchema = z.object({
  email: z.string().email().optional(),
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/change-password')({
  validateSearch: searchSchema,
  component: ChangePassword,
})
 